import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c631d83"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ammissione socio in corso", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Rinnova la tua iscrizione", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Paga la tua iscrizione", -1))
const _hoisted_4 = { class: "ion-text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "La tua tessera digitale")
], -1))
const _hoisted_6 = ["jsbarcode-value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Lista pagamenti", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Modifica i tuoi dati", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Richiedi eliminazione profilo", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Dashboard")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => ($options.refreshData($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          (_ctx.user)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_ion_card, { style: {"margin":"1rem","border-radius":"20px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.user.nome+' '+_ctx.user.cognome), 1)
                          ]),
                          _: 1
                        }),
                        (_ctx.user.Ammesso)
                          ? (_openBlock(), _createBlock(_component_ion_card_subtitle, { key: 0 }, {
                              default: _withCtx(() => [
                                _createElementVNode("strong", null, "SOCIO " + _toDisplayString(_ctx.user.tiposocio) + " - N° " + _toDisplayString(_ctx.user.codaica), 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_ion_card_subtitle, { key: 1 }, {
                              default: _withCtx(() => [
                                _hoisted_1
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }),
                    (!$options.hasUserRenewed && _ctx.user.Ammesso)
                      ? (_openBlock(), _createBlock(_component_ion_card_content, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, "Prossimo rinnovo dal " + _toDisplayString($options.getNextRenew.nextDate), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_progress_bar, {
                              value: $options.getNextRenew.progress
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                ($options.isRegistrationOpen)
                  ? (_openBlock(), _createBlock(_component_ion_card, {
                      key: 0,
                      style: {"margin":"1rem","border-radius":"20px"},
                      class: "ion-text-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            (_ctx.user.Quota.length>0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_ion_card_title, null, {
                                    default: _withCtx(() => [
                                      _hoisted_2
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_card_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("entro il " + _toDisplayString($options.getNextRenew.deadline), 1)
                                    ]),
                                    _: 1
                                  })
                                ], 64))
                              : (_openBlock(), _createBlock(_component_ion_card_title, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              color: "primary",
                              type: "block",
                              shape: "round",
                              onClick: $options.goToRenew
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Clicca qui per " + _toDisplayString(_ctx.user.Quota.length>0 ? 'rinnovare' : 'pagare'), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.user.Ammesso)
                  ? (_openBlock(), _createBlock(_component_ion_card, {
                      key: 1,
                      style: {"margin":"1rem","border-radius":"20px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_ion_text, null, {
                                default: _withCtx(() => [
                                  _hoisted_5
                                ]),
                                _: 1
                              }),
                              (_ctx.user && _ctx.user.codaica)
                                ? (_openBlock(), _createElementBlock("svg", {
                                    key: 0,
                                    class: "barcode",
                                    "jsbarcode-value": _ctx.user.codaica,
                                    "jsbarcode-textmargin": "0",
                                    "jsbarcode-fontoptions": "bold"
                                  }, null, 8, _hoisted_6))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_item, {
                  style: {},
                  class: "ion-activatable clickable-item rounded-rectangle",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({name: 'payments'})))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_ripple_effect),
                    _createVNode(_component_ion_text, null, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_icon, {
                      icon: $setup.chevronForwardOutline,
                      slot: "end"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  style: {},
                  class: "ion-activatable clickable-item rounded-rectangle",
                  onClick: $options.goToProfile
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_ripple_effect),
                    _createVNode(_component_ion_text, null, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_icon, {
                      icon: $setup.chevronForwardOutline,
                      slot: "end"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_ion_item, {
                  style: {},
                  class: "ion-activatable clickable-item rounded-rectangle",
                  onClick: $options.deleteProfile
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_ripple_effect),
                    _createVNode(_component_ion_text, null, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_icon, {
                      icon: $setup.chevronForwardOutline,
                      slot: "end"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}